import { Navigate, Outlet } from 'react-router-dom';
import { useProductsContext } from '../../context/ProductsContext';

export default function AdminRoute() {
  const { permissions } = useProductsContext();

  if (!permissions.canAccessAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
